export const getWidthByValueLength = (value: string) => {
  return (value.length + 1) * 8
}
